export enum TrackerClients {
  websdk = 'websdk',
  osm = 'osm-client-script',
  identitySdk = 'sign-in-with-klarna',
}
